<div class="ui-procedures-debit">
  <div *ngIf="isDebitSet">
    <h3 class="ui-procedures-debit-title ui-title" mat-dialog-title>Débito automático</h3>
    
    <div class="ui-procedures-debit-content" mat-dialog-content>
      La cuenta ya esta configurada en débito automatico mediante <strong>{{ (isDebitType == 'credit')? 'Tarjeta de crédito' : 'CBU' }}</strong>, ¿Desea modificarlo?
    </div>

    <div class="ui-procedures-debit-actions" mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cancelar</button>      
      <button class="ui-button" mat-button type="button" (click)="onRemove()">Anular débito</button>
      <button mat-button color="primary" cdkFocusInitial (click)="onUpdate()">Modificar</button>
    </div>
  </div>
  
  <div *ngIf="!isDebitSet">
    <h3 class="ui-procedures-debit-title ui-title" mat-dialog-title>Adherir al débito automático</h3> 
    
    <form class="ui-dialog" [formGroup]="formData">
      <div class="ui-procedures-debit-content" mat-dialog-content>
        <div class="ui-form">

          <div class="ui-form-row">
            <mat-form-field class="ui-input">
              <mat-label>Tipo de débito</mat-label>
              <mat-select formControlName="type">
                <mat-option value="cbu">CBU</mat-option>
                <mat-option value="credit">Tarjeta de credito</mat-option>
              </mat-select>
              <mat-error *ngIf="formHasError('type', 'validate')">{{formHasError('type', 'message')}}</mat-error>
            </mat-form-field>
          </div>

          <div class="ui-form-row" *ngIf="this.formData.get('type')?.value == 'cbu'">
            <mat-form-field class="ui-input">
              <mat-label>CBU</mat-label>
              <input matInput formControlName="cbu" type="text" />
              <mat-error *ngIf="formHasError('cbu', 'validate')">{{formHasError('cbu', 'message')}}</mat-error>
            </mat-form-field>
          </div>

          <div class="ui-form-row" *ngIf="this.formData.get('type')?.value == 'credit'">
            <mat-form-field class="ui-input">
              <mat-label>Número de tarjeta</mat-label>
              <input matInput formControlName="cardNumber" type="text" />
              <mat-error *ngIf="formHasError('cardNumber', 'validate')">{{formHasError('cardNumber', 'message')}}</mat-error>
            </mat-form-field>
          </div>

          <div class="ui-form-row" *ngIf="this.formData.get('type')?.value == 'credit'">
            <mat-form-field class="ui-procedures-debit-input-entity">
              <mat-label>Tarjeta</mat-label>
              <mat-select formControlName="cardEntity">
                <mat-option *ngFor="let card of cards" [value]="card.id">{{card.name}}</mat-option>
              </mat-select>
              <mat-error *ngIf="formHasError('cardEntity', 'validate')">{{formHasError('cardEntity', 'message')}}</mat-error>
            </mat-form-field>
            
            <mat-form-field class="ui-procedures-debit-input-date">
              <mat-label>Fecha de vencimiento</mat-label>
              <input matInput formControlName="cardDateExpiration" [matDatepicker]="datepicker" />
              <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker startView="multi-year" (yearSelected)="chosenYearHandler($event)" (monthSelected)="chosenMonthHandler($event, datepicker)" panelClass="ui-month-picker"></mat-datepicker>
              <mat-error *ngIf="formHasError('cardDateExpiration', 'validate')">{{formHasError('cardDateExpiration', 'message')}}</mat-error>
            </mat-form-field>
          </div>
          
          <div class="ui-form-row">
            <mat-form-field class="ui-procedures-debit-input-holder">
              <mat-label>Titular</mat-label>
              <input matInput formControlName="holder" type="text" />
              <mat-error *ngIf="formHasError('holder', 'validate')">{{formHasError('holder', 'message')}}</mat-error>
            </mat-form-field>
            
            <mat-form-field class="ui-procedures-debit-input-dni">
              <mat-label>DNI</mat-label>
              <input matInput formControlName="dni" type="text" />
              <mat-error *ngIf="formHasError('dni', 'validate')">{{formHasError('dni', 'message')}}</mat-error>
            </mat-form-field>
          </div>

          <div class="ui-form-row">
            <mat-form-field class="ui-input">
              <mat-label>Banco</mat-label>
              <mat-select formControlName="bank">
                <mat-option *ngFor="let bank of banks" [value]="bank.id">{{bank.name}}</mat-option>
              </mat-select>
              <mat-error *ngIf="formHasError('bank', 'validate')">{{formHasError('bank', 'message')}}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      
      <div class="ui-procedures-debit-actions" mat-dialog-actions>
        <button class="ui-button" mat-button type="button" (click)="onCancel()">Cancelar</button>
        <button class="ui-button" mat-button type="button" (click)="onSend()" color="primary" cdkFocusInitial>Adherirme</button>
      </div>
    </form>
  </div>
</div>